<script setup lang="ts">
import { ref, computed, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { format } from "date-fns";
import LeaderboardListItem from "@/components/LeaderboardListItem.vue";
import EventListItem from "@/components/EventListItem.vue";
import SummarySection from "@/components/SummarySection.vue";
import TimeButtons from "@/components/TimeButtons.vue";
import useLeaderboard from "@/modules/useLeaderboard";
import PokerRunEventDataService from "@/services/PokerRunEventDataService";
import useDate from "@/modules/useDate";

const { getDate } = useDate();
const { leaderboard, getLeaderboard, unsubscribeLeaderboard } = useLeaderboard();
const route = useRoute();
const eventId = route.params.id as string;
const pokerRunEvent = ref({});

getLeaderboard(eventId, []);
onUnmounted(unsubscribeLeaderboard);
const initalize = async () => {
  pokerRunEvent.value = await PokerRunEventDataService.get(eventId);
};
initalize();
</script>
<template>
  <AppEventContainer>
    <SummarySection
      v-if="pokerRunEvent.id"
      class="mt-4"
      :show-completed="false"
      :is-completed="false"
      :show-edit="false"
      name="Event Info"
    >
      <div class="event-summary">
        <label>Event Name:</label>
        <p>
          {{ pokerRunEvent.name }}
        </p>
      </div>
      <div class="event-summary">
        <label>Event Type:</label>
        <p>
          {{ pokerRunEvent.eventType }}
        </p>
      </div>
      <div class="event-summary">
        <label>Event Date:</label>
        <p>
          {{ format(getDate(pokerRunEvent.eventDate), "MMMM d, yyyy") }}
        </p>
      </div>
      <div class="event-summary">
        <label>Registration Begins:</label>
        <p>
          {{
            format(
              getDate(pokerRunEvent.eventSettings.registrationStartDate),
              "MMMM d, yyyy"
            )
          }}
        </p>
      </div>

      <div class="event-summary">
        <label>Event Details:</label>
        <p>
          {{ pokerRunEvent.description }}
        </p>
      </div>
    </SummarySection>
    <AppSectionHeader>Results</AppSectionHeader>
    <div class="content-centered mb-2">
      <table class="leaderboard-list mt-2">
        <tbody>
          <tr class="leaderboard-header">
            <th colspan="2">Rank</th>
            <th>Participant</th>
            <th class="leaderboard-hand">Hand</th>
          </tr>
          <template
            v-for="(item, index) in leaderboard"
            :key="`rank-${eventId}-${index}`"
          >
            <LeaderboardListItem :item="item" />
          </template>
        </tbody>
      </table>
    </div>
    <router-link
      class="is-underlined"
      :to="{ name: 'Leaderboard', params: { id: eventId } }"
    >
      View full event results</router-link
    >
  </AppEventContainer>
</template>
